import { render, staticRenderFns } from "./TabUnidadeAdministrativa.vue?vue&type=template&id=db9ea3c6"
import script from "./TabUnidadeAdministrativa.vue?vue&type=script&lang=js"
export * from "./TabUnidadeAdministrativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports